import { ArrowLeftRight, Info } from "lucide-react";
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { ScaledThumbnail } from "./ScaledThumbnail";

interface UncategorizedItemsCardThumbnailProps {
  isHovered?: boolean;
  alwaysVisible?: boolean;
}

export default function UncategorizedItemsCardThumbnail({
  isHovered = false,
  alwaysVisible = false,
}: UncategorizedItemsCardThumbnailProps) {
  return (
    <ScaledThumbnail
      isHovered={isHovered}
      alwaysVisible={alwaysVisible}
      contentWidth={340}
    >
      <Card
        className="w-[340px]"
        style={{ borderLeft: "3px solid var(--mc-error-border)" }}
      >
        <CardContent className="p-4 flex flex-col">
          <div className="flex items-start justify-between gap-2">
            <div className="flex items-center gap-1 min-w-0">
              <span className="text-base font-medium text-neutral-800 truncate">
                Uncategorised Transactions
              </span>
              <Info className="h-3 w-3 text-muted-foreground flex-shrink-0" />
            </div>
            <div
              className="flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center"
              style={{ backgroundColor: "var(--mc-error-bg)" }}
            >
              <ArrowLeftRight
                className="w-5 h-5"
                style={{ color: "var(--mc-error-icon)" }}
              />
            </div>
          </div>

          <div className="text-2xl font-bold text-neutral-900 tracking-tight mt-2">
            12
          </div>

          <div className="mt-1">
            <span className="text-xs font-semibold text-neutral-900">
              Categorise Now
            </span>
          </div>
        </CardContent>
      </Card>
    </ScaledThumbnail>
  );
}
